import e from "react";
import { useLocation as _, matchRoutes as s, Routes as p, Route as h } from "react-router-dom";
import { TransitionGroup as k } from "react-transition-group";
import { tint as f } from "../../../../../../../common/libs/tint.js";
import { useWindowSize as b } from "../../../../../dom/hooks/useWindowSize.js";
import { SwipeRightTransition as i } from "../../../../../animations/transitions/SwipeRightTransition/SwipeRightTransition.js";
import n from "./routeMenu.module.scss.js";
function S({
  routes: m,
  design: o
}) {
  const a = _(), {
    isDesktop: r
  } = b(), [{ route: c } = {}] = s(m, a) ?? [], y = f(0.8, o.content.textColor ?? "#000"), l = m.find((t) => t.path === (c == null ? void 0 : c.path));
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      style: {
        "--borderColor": y,
        backgroundColor: (o == null ? void 0 : o.content.backgroundColor) ?? "#FFF",
        color: (o == null ? void 0 : o.content.textColor) ?? "#000"
      },
      className: n.routeMenu
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: n.routeMenu__left,
        style: {
          backgroundColor: (o == null ? void 0 : o.content.backgroundColor) ?? "#FFF"
        }
      },
      r && /* @__PURE__ */ e.createElement("div", { className: n.routeMenu__left__content }, /* @__PURE__ */ e.createElement(k, { component: null }, /* @__PURE__ */ e.createElement(
        i,
        {
          key: (l == null ? void 0 : l.desktop.left.key) ?? a.pathname,
          style: {
            height: "100%"
          },
          enter: 150,
          exit: 0
        },
        /* @__PURE__ */ e.createElement(p, { location: a }, m.map((t, E) => /* @__PURE__ */ e.createElement(
          h,
          {
            key: t.desktop.left.key ?? t.path,
            path: t.path,
            element: t.desktop.left.element
          }
        )))
      ))),
      !r && /* @__PURE__ */ e.createElement("div", { className: n.routeMenu__left__content }, /* @__PURE__ */ e.createElement(k, { component: null }, /* @__PURE__ */ e.createElement(
        i,
        {
          key: (l == null ? void 0 : l.mobile.key) ?? a.pathname,
          style: {
            height: "100%"
          },
          enter: 150,
          exit: 0
        },
        /* @__PURE__ */ e.createElement(p, { location: a }, m.map((t, E) => /* @__PURE__ */ e.createElement(
          h,
          {
            key: t.mobile.key ?? t.path,
            path: t.path,
            element: t.mobile.element
          }
        )))
      )))
    ),
    r && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: n.routeMenu__right,
        style: {
          "--borderColor": y,
          backgroundColor: (o == null ? void 0 : o.content.backgroundColor) ?? "#FFF"
        }
      },
      /* @__PURE__ */ e.createElement("div", { className: n.routeMenu__right__content }, /* @__PURE__ */ e.createElement(k, { component: null }, /* @__PURE__ */ e.createElement(
        i,
        {
          key: (l == null ? void 0 : l.desktop.right.key) ?? a.pathname,
          style: {
            height: "100%"
          },
          enter: 150,
          exit: 0
        },
        /* @__PURE__ */ e.createElement(p, { location: a }, m.map((t, E) => /* @__PURE__ */ e.createElement(
          h,
          {
            key: t.desktop.right.key ?? t.path,
            path: t.path,
            element: t.desktop.right.element
          }
        )))
      )))
    )
  );
}
export {
  S as RouteMenu
};
//# sourceMappingURL=RouteMenu.js.map
